import { Collapse, Divider, Popover, Stack } from '@mui/material';
import { AdvancedSearchPaper } from 'Components/AdvancedSearchPaper';
import { AdvancedSearchTitle } from 'Components/AdvancedSearchTitle';
import { useIsDesktop } from 'Hooks';
import { useContext, useEffect, useRef, useState } from 'react';
import { SearchBySubject } from './SearchBySubject';
import { SearchFields } from './SearchFields';
import { DateFields } from './DateFields';
import { Buttons } from './Buttons';
import { AdvancedSearchContext } from 'Context/PaymentDeductionContext/AdvancedSearchProvider';
import { IPaymentsAndDeductions } from 'API/paymentAndDeductions';
import { maxPaymentsAndDeductionsPerPage } from '..';

interface ISearchFilter {
  paymentsDeductions: IPaymentsAndDeductions[];
  dispatchPaymentsDeductions: Function;
  dateMinMaxRange: {
    min: Date;
    max: Date;
  };
  loadAllPaymentsDeductions: Function;
  paymentsDeductionsCount: number;
  advancedSearchOpen: boolean;
  setAdvancedSearchOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SearchFilter = ({
  paymentsDeductions,
  dispatchPaymentsDeductions,
  dateMinMaxRange,
  loadAllPaymentsDeductions,
  paymentsDeductionsCount,
  advancedSearchOpen,
  setAdvancedSearchOpen,
}: ISearchFilter) => {
  const isDesktop = useIsDesktop();

  const { dispatchAdvancedSearch } = useContext(AdvancedSearchContext);

  useEffect(() => {
    dispatchAdvancedSearch({
      type: 'SEARCH_FIELDS_DATA_INITIALIZATION',
      payload: { value: { dateMinMaxRange, paymentsDeductions } },
    });
  }, [dateMinMaxRange, paymentsDeductions, dispatchAdvancedSearch]);

  useEffect(() => {
    if (
      advancedSearchOpen &&
      paymentsDeductionsCount === maxPaymentsAndDeductionsPerPage
    )
      loadAllPaymentsDeductions();
  }, [advancedSearchOpen]);

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      justifyContent='space-between'
      alignItems={'flex-end'}
      flexWrap='wrap'
      gap={isDesktop ? '12px' : '32px'}
    >
      <SearchBySubject
        dispatchPaymentsDeductions={dispatchPaymentsDeductions}
        paymentsAndDeductions={paymentsDeductions}
      />
      {!advancedSearchOpen && (
        <AdvancedSearchTitle
          advancedSearchOpen={advancedSearchOpen}
          openAdvancedSearch={() => setAdvancedSearchOpen(true)}
          ariaControls={'advanced-search-paper'}
        />
      )}
      {advancedSearchOpen && (
        <AdvancedSearchPaper
          scroll={!isDesktop}
          closeAdvancedSearch={setAdvancedSearchOpen}
        >
          <SearchFields />
          <Divider
            aria-hidden={'true'}
            sx={{
              width: '100%',
              height: '1px',
              borderColor: 'primary.shade_100',
            }}
          />
          <DateFields />
          <Buttons
            closeAdvancedSearch={setAdvancedSearchOpen}
            dispatchPaymentsDeductions={dispatchPaymentsDeductions}
          />
        </AdvancedSearchPaper>
      )}
    </Stack>
  );
};
